export enum OnFarmBillingMode {
  FlatUpToMax = 'FlatUpToMax',
  PerPeakTank = 'PerPeakTank',
}

export interface OnFarmStorageRateTier {
  name: string;
  minTanks: number;
  maxTanks?: number | null;
  costInCents: number;
  includedUnitsPerTank: number;
  billingMode: OnFarmBillingMode | string;
  period: string;
  description?: string;
}

export interface OnFarmStorageRatesResponse {
  flatMonthlyCents: number;
  maxStandardTanks: number;
  includedUnitsPerTank: number;
  ratePerTankCents: number;
  billingMode: OnFarmBillingMode | string;
  tiers: OnFarmStorageRateTier[];
}
